module.exports = __webpack_public_path__ + "img/bannercn2.06041f8e.png";